import { render, staticRenderFns } from "./ChunkUploadNew.vue?vue&type=template&id=5f01ba12"
import script from "./ChunkUploadNew.vue?vue&type=script&lang=js"
export * from "./ChunkUploadNew.vue?vue&type=script&lang=js"
import style0 from "./ChunkUploadNew.vue?vue&type=style&index=0&id=5f01ba12&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports